import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { ConsultationService } from "../../services/ConsultationService";
import Loader from "../Common/Loader";

const ConsultationForm = (props) => {
  const { submitBtnClass, btnText } = props;
  const [isLoading, setLoading] = useState(false);
  const [services, setServices] = useState([]);
  const [input, setInput] = useState({
    firstName: "",
    lastName: "",
    companyName: "",
    officialEmail: "",
    phoneNumber: "",
    pickDate: "",
    setTime: "",
    consultationServiceId: "",
    notes: "",
  });

  useEffect(() => {
    // Fetch services for dropdown
    ConsultationService.getServices()
      .then((response) => {
        console.log("Services response:", response.data);
        if (response.data.success && response.data.data && response.data.data.page) {
          setServices(response.data.data.page);
        } else {
          console.log("No services found or invalid response structure");
          setServices([]);
        }
      })
      .catch((ex) => {
        console.log("Error fetching services:", ex);
        setServices([]);
      });
  }, []);

  // Ensure services is always an array
  const servicesList = Array.isArray(services) ? services : [];

  const submit = () => {
    if (
      input.firstName &&
      input.lastName &&
      input.companyName &&
      input.officialEmail &&
      input.phoneNumber &&
      input.pickDate &&
      input.setTime &&
      input.consultationServiceId
    ) {
      // Basic email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(input.officialEmail)) {
        Swal.fire({
          title: "Validation Failed!",
          text: "Invalid email address",
          icon: "error",
        });
        return;
      }
      setLoading(true);
      
      // Prepare request data with proper types
      const requestData = {
        ...input,
        consultationServiceId: parseInt(input.consultationServiceId, 10)
      };
      
      ConsultationService.add(requestData)
        .then((response) => {
          setLoading(false);
          if (response.data.success) {
            Swal.fire({
              title: "Success!",
              text: "Your consultation has been booked successfully. We will contact you soon!",
              icon: "success",
            });
            setInput({
              firstName: "",
              lastName: "",
              companyName: "",
              officialEmail: "",
              phoneNumber: "",
              pickDate: "",
              setTime: "",
              consultationServiceId: "",
              notes: "",
            });
          } else {
            Swal.fire({
              title: "Oops!",
              text: response.data.message,
              icon: "error",
            });
          }
        })
        .catch((ex) => {
          setLoading(false);
          Swal.fire({
            title: "Oops!",
            text: "Something went wrong. Please try again later.",
            icon: "error",
          });
        });
    } else {
      Swal.fire({
        title: "Validation Failed!",
        text: "All fields except notes are required!",
        icon: "error",
      });
    }
  };

  return (
    <div id="consultation-form">
      <div className="row">
        <div className="col-md-6 mb-30">
          <input
            className="from-control"
            type="text"
            id="firstName"
            name="firstName"
            value={input.firstName}
            placeholder="First Name"
            required
            onChange={(e) => setInput({ ...input, firstName: e.target.value })}
          />
        </div>
        <div className="col-md-6 mb-30">
          <input
            className="from-control"
            type="text"
            id="lastName"
            name="lastName"
            value={input.lastName}
            placeholder="Last Name"
            required
            onChange={(e) => setInput({ ...input, lastName: e.target.value })}
          />
        </div>
        <div className="col-md-6 mb-30">
          <input
            className="from-control"
            type="text"
            id="companyName"
            name="companyName"
            value={input.companyName}
            placeholder="Company Name"
            required
            onChange={(e) => setInput({ ...input, companyName: e.target.value })}
          />
        </div>
        <div className="col-md-6 mb-30">
          <input
            className="from-control"
            type="email"
            id="officialEmail"
            name="officialEmail"
            value={input.officialEmail}
            placeholder="Official Email"
            required
            onChange={(e) => setInput({ ...input, officialEmail: e.target.value })}
          />
        </div>
        <div className="col-md-6 mb-30">
          <input
            className="from-control"
            type="text"
            id="phoneNumber"
            name="phoneNumber"
            value={input.phoneNumber}
            placeholder="Phone Number"
            required
            onChange={(e) => setInput({ ...input, phoneNumber: e.target.value })}
          />
        </div>
        <div className="col-md-6 mb-30">
          <select
            className="from-control"
            id="consultationServiceId"
            name="consultationServiceId"
            value={input.consultationServiceId}
            required
            onChange={(e) => setInput({ ...input, consultationServiceId: e.target.value })}
          >
            <option value="">Select Service</option>
            {servicesList.map((consultationService) => (
              <option key={consultationService.id} value={consultationService.id}>
                {consultationService.title}
              </option>
            ))}
          </select>
        </div>
        <div className="col-md-6 mb-30">
          <input
            className="from-control"
            type="date"
            id="pickDate"
            name="pickDate"
            value={input.pickDate}
            placeholder="Pick Date"
            required
            onChange={(e) => setInput({ ...input, pickDate: e.target.value })}
          />
        </div>
        <div className="col-md-6 mb-30">
          <input
            className="from-control"
            type="time"
            id="setTime"
            name="setTime"
            value={input.setTime}
            placeholder="Set Time"
            required
            onChange={(e) => setInput({ ...input, setTime: e.target.value })}
          />
        </div>
        <div className="col-12 mb-30">
          <textarea
            className="from-control"
            id="notes"
            name="notes"
            value={input.notes}
            placeholder="Notes (optional)"
            onChange={(e) => setInput({ ...input, notes: e.target.value })}
          ></textarea>
        </div>
      </div>
      <div className="btn-part">
        <button
          className={submitBtnClass ? submitBtnClass : "readon learn-more submit"}
          type="submit"
          onClick={isLoading ? null : submit}
        >
          {isLoading ? <Loader /> : btnText || "Request Demo"}
        </button>
      </div>
    </div>
  );
};

export default ConsultationForm; 